import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { eventBookings } from '../../../../../redux/event/event-bookings/action';
import EventBookingsComponent from '../components/event-booking.component';
import { selectListItems } from '../../../../../redux/library/selector';
import { events } from '../../../../../redux/event/events/action';
import { selectEventsListItems } from '../../../../../redux/event/events/selector';
import { eventTickets } from '../../../../../redux/event/event-tickets/action';
import { selectEventTicketsListItems } from '../../../../../redux/event/event-tickets/selector';
import { users } from '../../../../../redux/users/action';
import { selectUsersListItems } from '../../../../../redux/users/selector';
import { selectEventBookingsQueryItems } from '../../../../../redux/event/event-bookings/selector';

const AgencyEventBooking = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const eventBookingsQuery = useSelector(selectEventBookingsQueryItems);
  const libraryData = useSelector(selectListItems)
  const userItems = useSelector(selectUsersListItems)
  const eventTicketsItemsData = useSelector(selectEventTicketsListItems);
  const eventsItemsData = useSelector(selectEventsListItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectEventBookings, setSelectEventBookings] = useState<any>({
      "EventId": 0,
      "EventTicketId": 0,
      "UserProfileId": 0,
      "Quantity": 0,
      "TotalAmount": 0,
      "Currency": "",
      "BookingStatus": "",
      "CheckInStatus": "",
      "QrCode": "",
      "BookingDate": "2025-05-04T15:53:49.989Z",
      "IsActive": true
    
  });

  const fetchEventBookingsQueryById = () => {
    dispatch(eventBookings.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/bookings/query`,
      entity: 'eventBookings',
      jsonData: {
        Records: [
          {
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectEventBookings({ ...selectEventBookings, [field]: event });
  }

  const handleBasicFormChange: any = (event: any, field: string) => {
    setSelectEventBookings({ ...selectEventBookings, [field]: event });
  }

 useEffect(
     () => {
        dispatch(events.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/events/list`,entity:'events',jsonData:{
           
         }})) .then(() => {
               dispatch(eventTickets.list({
                           url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/tickets/list`,
                 entity: 'lmsLearningPath',
                 jsonData: {}
               }))
               }).then(()=>{
                           dispatch(users.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/iam/users/list`,entity:'users',jsonData:{
                         
                       }}))
         
              }).then(() => {
                if (parmas?.id > 0) {
                  fetchEventBookingsQueryById()
                  setIsLoading(false)
                } else {
                  setIsLoading(false)
                }
              })
  }, []);

  useEffect(() => {
    if (isQuery) {
        setSelectEventBookings(eventBookingsQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(eventBookings.resetAction({ actionType: 'update' }))
      await dispatch(eventBookings.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/bookings`,
        entity: 'eventBookings',
        jsonData: {
          records: [
            selectEventBookings
          ]
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(eventBookings.resetAction({ actionType: 'create' }))
      await dispatch(eventBookings.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/event/bookings`,
        entity: 'eventBookings',
        jsonData: {
          Records: [
            selectEventBookings
          ]
        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/agencies/event/event-bookings');
  }

  return (
    <>
      {eventBookingsQuery?.isLoading ? <PageLoader /> :
        <EventBookingsComponent
          handleInnerFormChange={handleInnerFormChange}
          users={userItems?.result?.items}
          events={eventsItemsData?.result?.items} 
          eventTickets={eventTicketsItemsData?.result?.items} 
          selectEventBookings={selectEventBookings}
          handleBasicFormChange={handleBasicFormChange}
          libraryData={libraryData}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  );
}

export default AgencyEventBooking;
